import { Moment } from "moment-timezone";
import { Hash } from "../@types/apiTypes";
import { ApiResponse } from "../apiResponse";
import ApiDateParser from "../../helpers/parsers/apiDateParser";

export default class LearnerAvailableSlotsModel {
  unparsedSlots: Hash<number[]>;

  constructor(data: Hash<number[]>) {
    this.unparsedSlots = data;
  }

  static fromApiResponse(response: ApiResponse): LearnerAvailableSlotsModel {
    return new LearnerAvailableSlotsModel(response.data as Hash<number[]>);
  }

  availableEntries(): [string, number[]][] {
    return Object.entries(this.unparsedSlots).filter(
      ([key, value]) => value.length > 0
    );
  }

  parsedAvailableDates(): Moment[] {
    return this.availableEntries().flatMap(([dateStr, epochArr]) =>
      epochArr.map((epoch) =>
        ApiDateParser.combinedDateEpochParseLocal(dateStr, epoch)
      )
    );
  }

  toLocalSlots(): Hash<Moment[]> {
    const parsedAvailableSlots = this.parsedAvailableDates();
    const localSlotsHash: Hash<Moment[]> = {};
    parsedAvailableSlots.forEach((date) => {
      const dateFormat = "YYYY-MM-DD";
      const key = date.format(dateFormat);
      if (!localSlotsHash[key]) localSlotsHash[key] = [];
      localSlotsHash[key].push(date);
    });
    return localSlotsHash;
  }
}
